import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as classNames from 'classnames';
import { Grid } from '@emburse/ui-core';
import { Icon } from '@emburse/ui-essentials';
import { EMBURSE_SPEND_WHITELABEL_ID } from '@Shared/constants';
import * as style from './EmburseAccountsPageContainer.styl';
/**
 * A component designed to mimic the appearance of the Emburse Accounts login page
 * Shows content on the left and a stock image of a woman on the right
 * @param props.children The content to display on the left side of the page
 * @returns
 */
export const EmburseAccountsPageContainer = ({ className, children }) => {
    function renderEmburseLogo() {
        if (window.whitelabelConfiguration.id === EMBURSE_SPEND_WHITELABEL_ID) {
            return _jsx(Icon, { iconUrl: 'img/logo/emburseSpendLogoWhite.svg', className: "emburseLogo" });
        }
        return null;
    }
    return (_jsxs(Grid, Object.assign({ className: classNames(style.global, className), container: true, direction: "row", justifyContent: "center", style: { height: '100%' } }, { children: [_jsx(Grid, Object.assign({ item: true, lg: 5, className: "formGrid" }, { children: children })), _jsx(Grid, Object.assign({ item: true, md: 0, className: "baseImageGrid" }, { children: _jsxs("div", Object.assign({ className: "baseImageContainer" }, { children: [_jsx("img", { className: "baseImage", src: '/img/login_background_image.jpg', alt: "background" }), renderEmburseLogo()] })) }))] })));
};
